import { useEffect, useState } from "react";

export type DeviceType = "mobile" | "pc";

/**
 * クライアントサイドでモバイル / PC を判定するカスタムフック
 */
export const useDeviceType = (): DeviceType => {
    const [deviceType, setDeviceType] = useState<DeviceType>("pc");

    useEffect(() => {
        if (typeof window === "undefined") return;

        const userAgent = window.navigator.userAgent;
        const isMobile =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                userAgent
            );

        setDeviceType(isMobile ? "mobile" : "pc");
    }, []);

    return deviceType;
};
